/* APPLICATION ROUTE CONSTANTS */
module.exports = Object.freeze({
  ROW_PER_PAGE: [10, 50, 100, 300, 500],

  // Status
  STATUS_REGISTER: "Register",

  /* Routers Link supplier_app */
  APP_HOME: "/applications",
  HOME: "/home",

  HOME_INTRO: "/warehouse-intro",
  DASHBOARD: "/warehouse-dashboard",
  INBOX: "/warehouse-inbox",
  OUTBOX: "/warehouse-outbox",

  WAREHOUSE_MATERIAL_LIST: "/wh-material-list",
  WAREHOUSE_MATERIAL_BARCODE_LIST: "/wh-material-barcode-list",
  WAREHOUSE_MATERIAL_BARCODE_SALE_LIST: "/wh-sale-material-barcode-list",
  WAREHOUSE_MATERIAL_BARCODE_RENT_LIST: "/wh-rent-material-barcode-list",

  WH_MAT_INDENT_CREATION: "/wh-mat-indent-creation",
  WH_MAT_INDENT_LIST: "/wh-mat-indent-list",
  WH_MAT_INDENT_DETAILS: "/wh-mat-indent-details",

  WH_CREATE_PO: "/wh-create-po",
  WH_PO_LIST: "/wh-po-list",
  WH_PO_DETAILS: "/wh-po-details",

  WH_PRODUCTION_ORDER_CREATION: "/production-order-create",
  WH_PRODUCTION_ORDER_LIST: "/production-order-list",
  WH_PRODUCTION_ORDER_DETAILS: "/production-order-details",

  //Stock
  WH_STOCK_LIST: "/stock-list",
  WH_STOCK_CREATION: "/stock-creation",
  WH_STOCK_DETAILS: "/stock-details",

  //Warehouse
  WH_WAREHOUSE_LIST: "/warehouse-list",
  WH_WAREHOUSE_CREATION: "/warehouse-creation",
  WH_WAREHOUSE_DETAILS: "/warehouse-details",

  WH_ORDER_CREATION: "/order-creation",
  WH_ORDER_DETAILS: "/order-details",
  WH_ORDER_LIST: "/order-list",
});
